var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3514 10.3266C20.3514 15.4333 14.5001 21.8847 10.9893 21.8847C7.4785 21.8847 1.6272 15.4333 1.6272 10.3266C1.6272 5.21988 5.81875 1.08008 10.9893 1.08008C16.1598 1.08008 20.3514 5.21988 20.3514 10.3266Z",
    stroke: "#67A0C2",
    strokeWidth: 1.56035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.11 10.4422C14.11 12.1657 12.7128 13.5629 10.9893 13.5629C9.26577 13.5629 7.86859 12.1657 7.86859 10.4422C7.86859 8.71865 9.26577 7.32147 10.9893 7.32147C12.7128 7.32147 14.11 8.71865 14.11 10.4422Z",
    stroke: "#67A0C2",
    strokeWidth: 1.56035
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cff5849cb4ffba280185db173ef791a3.svg";
export { ForwardRef as ReactComponent };